import React from 'react';
import PropTypes from 'prop-types';
import { StateEnumTag } from '@constants/state.enum';
import styles from './UiTag.module.scss';

export interface UiTagProps {
  type: StateEnumTag;
  text: string | number;
  icon?: React.ReactNode;
}

const UiTag: React.FC<UiTagProps> = ({ type, icon, text }) => {
  return (
    <div className={styles[type]} data-testid={`ui-tag-${type}`}>
      {icon && (
        <span className={styles.icon} data-testid={`ui-tag-icon-${type}`}>
          {icon}
        </span>
      )}
      <span className={`uppercase small-caps-regular ${styles.text}`}>{text}</span>
    </div>
  );
};

UiTag.propTypes = {
  type: PropTypes.oneOf(Object.values(StateEnumTag)).isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.element,
};

UiTag.defaultProps = {
  icon: undefined,
};

export default UiTag;
